import { render, staticRenderFns } from "./channel-list.html?vue&type=template&id=05d540b8&scoped=true&"
import script from "./channel-list.js?vue&type=script&lang=js&"
export * from "./channel-list.js?vue&type=script&lang=js&"
import style0 from "./channel-list.scss?vue&type=style&index=0&id=05d540b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d540b8",
  null
  
)

export default component.exports